import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
  console.log(`PrivateRoute [${rest.path}] - isLoggedIn:`, isLoggedIn);

  return (
    <Route
      {...rest}
      render={props =>
        isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login", 
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;